import React, { Dispatch, SetStateAction } from 'react';
import { IBreadcrumb } from 'common/interfaces/common';

export interface IBreadcrumbContext {
  breadcrumbs: IBreadcrumb[];
  setBreadcrumbs: Dispatch<SetStateAction<IBreadcrumb[]>>;
  updateLastBreadcrumbLabel: (label: string) => void;
}

const BreadcrumbContext = React.createContext<IBreadcrumbContext>({
  breadcrumbs: [],
  setBreadcrumbs: () => {},
  updateLastBreadcrumbLabel: () => {},
});

export default BreadcrumbContext;
